module.exports = require("dyna-crypt");